import {testVideoInputDevice, VideoInputTest} from "@twilio/rtc-diagnostics";
import {useState, useRef, useCallback} from "react";
let videoTest;
export function useCameraTest() {
  const videoElementRef = useRef(null);
  const [videoTestError, setVideoTestError] = useState();
  const [videoTestReport, setVideoTestReport] = useState();
  const stopVideoTest = useCallback(() => {
    videoTest == null ? void 0 : videoTest.stop();
    videoTest = void 0;
  }, [videoTest]);
  const startVideoTest = useCallback((deviceId) => {
    stopVideoTest();
    const test = testVideoInputDevice({element: videoElementRef.current, deviceId});
    videoTest = test;
    test.on(VideoInputTest.Events.Error, (err) => setVideoTestError(err));
    test.on(VideoInputTest.Events.End, (report) => setVideoTestReport(report));
  }, [stopVideoTest]);
  return {startVideoTest, stopVideoTest, videoElementRef, videoTest, videoTestError, videoTestReport};
}
